import { defineFetch } from 'resift';
import * as Types from 'pages/Pages/typings';

const makeCreateEntity = defineFetch({
  displayName: 'Entities Batch Action',
  make: () => ({
    request: ({ actions, entityTypeId }: Types.BatchEntityActionRequest) => ({ http }) =>
      http({
        method: 'PUT',
        route: '/entities',
        data: { entityTypeId, actions },
      }),
  }),
});

const createEntity = makeCreateEntity();

export default createEntity;
